/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const PatternIcon = ({ width = 24, height = 24, hidden = false, title = 'Pattern' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 20 20"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M11.94454,14.41942c-.29279.29279-.76787.29279-1.06066,0l-2.12132-2.12132c-.29279-.29279-.29279-.76787,0-1.06066s.76787-.29279,1.06066,0l2.12132,2.12132c.29279.29279.29279.76787,0,1.06066Z"
      fill="currentColor"
    />
    <path
      d="M15.12652,9.11612l-2.12132,2.12132c-.29279.29279-.76787.29279-1.06066,0s-.29279-.76787,0-1.06066l2.12132-2.12132c.29279-.29279.76787-.29279,1.06066,0s.29279.76787,0,1.06066Z"
      fill="currentColor"
    />
    <path
      d="M11.23744,8.76256c-.29279.29279-.76787.29279-1.06066,0l-2.12132-2.12132c-.29279-.29279-.29279-.76787,0-1.06066s.76787-.29279,1.06066,0l2.12132,2.12132c.29279.29279.29279.76787,0,1.06066Z"
      fill="currentColor"
    />
    <path
      d="M8.05546,9.82322l-2.12132,2.12132c-.29279.29279-.76787.29279-1.06066,0s-.29279-.76787,0-1.06066l2.12132-2.12132c.29279-.29279.76787-.29279,1.06066,0s.29279.76787,0,1.06066Z"
      fill="currentColor"
    />
    <path
      d="M15.75,2H4.25c-1.24072,0-2.25,1.00977-2.25,2.25v11.5c0,1.24023,1.00928,2.25,2.25,2.25h11.5c1.24072,0,2.25-1.00977,2.25-2.25V4.25c0-1.24023-1.00928-2.25-2.25-2.25ZM15.75,16.5h-1.64331l.31274-.31274c.29272-.29272.29272-.76782,0-1.06079-.29272-.29272-.76782-.29272-1.06055,0l-1.37354,1.37354h-4.24268l1.02002-1.02002c.29272-.29272.29272-.76782,0-1.06055-.29297-.29297-.76807-.29297-1.06079,0l-2.08057,2.08057h-1.37134c-.41357,0-.75-.33691-.75-.75v-.93628l.31274.31274c.29272.29297.76782.29297,1.06079,0,.29272-.29272.29272-.76782,0-1.06055l-1.37354-1.37354v-5.65674l1.02002,1.01978c.29272.29272.76782.29272,1.06055,0s.29272-.76782,0-1.06079l-2.08057-2.08057v-.66406c0-.41309.33643-.75.75-.75h1.64331l-.31274.31274c-.29272.29272-.29272.76782,0,1.06079.29272.29272.76782.29272,1.06055,0l1.37354-1.37354h4.24268l-1.02002,1.02002c-.29272.29272-.29272.76782,0,1.06055.29297.29272.76807.29272,1.06079,0l2.08057-2.08057h1.37134c.41357,0,.75.33691.75.75v.93628l-.31274-.31274c-.29272-.29297-.76782-.29297-1.06079,0-.29272.29272-.29272.76782,0,1.06055l1.37354,1.37354v5.65674l-1.02002-1.01978c-.29272-.29272-.76782-.29272-1.06055,0s-.29272.76782,0,1.06055l2.08057,2.08081v.66406c0,.41309-.33643.75-.75.75Z"
      fill="currentColor"
    />
  </svg>`;
};
